import { login } from 'api/login/login';
import server from 'utils/request';

const user = {
  state: {
    username: '',
    userInfo: null
  },

  mutations: {
    SET_NAME: (state, name) => {
      state.username = name;
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data;
    }
  },
  actions: {
    login({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data).then(res => {
          if (res.type === 'success') {
            localStorage.setItem('sessionId', res.data.sessionId);
            localStorage.setItem('username', res.data.userName);
            localStorage.setItem('userAccount', res.data.account);
            localStorage.setItem('division', res.data.permissions.indexOf(11));
            // new jsonpRequest(res.data.ssoUrl);
            setTimeout(function () {
              resolve();
            }, 5)
          } else {
            reject(res);
          }
        })
      });
    }
  }
};

export default user;


function jsonpRequest(url) {
  this._ajaxTimer && clearTimeout(this._ajaxTimer);
  this._ajaxTimer = setTimeout(function () {

    var request_script = document.createElement('script');
    request_script.setAttribute("id", "request_script");
    request_script.src = url;
    window.callback = function (response) {
      // 移除脚本
      document.body.removeChild(document.getElementById('request_script'));
      console.log(response.content);
    }
    document.body.appendChild(request_script);
  }, 500);
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js